import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'

import ConfigManage from './ConfigManage'

const StaticPages = () => {
    const [isLoading, setIsLoading] = useState(true)
    const alertContext = useContext(AlertContext)
    const settingContext = useContext(SettingContext)
    const history = useHistory()
    const { setAlert } = alertContext
    const {
        configurations,
        getAllConfigurations,
        responseStatus: responseStatusCommuncation,
    } = settingContext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            filters: true,
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllConfigurations(values)
        },
    })

    useEffect(() => {
        if (configurations) {
            setTableBody(
                configurations.records.length ? configurations.records : []
            )
            setIsLoading(false)
        }
    }, [configurations])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllConfigurations(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from ===
                    'CommunicationStaticPages' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllConfigurations(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const tableValues = [
        {
            field: 'question',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Settings',
            filterable: true,
            filterField: 'question',
        },
        {
            field: 'value',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Value',
            filterable: true,
            filterField: 'value',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
        },
    ]

    const searchInfo = [
        {
            label: 'Settings',
            placeholder: 'Enter Settings Title',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="configView_variable_new"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Variable
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={configurations}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllConfigurations}
                />
            </div>
            <ConfigManage data={manage} function={toggleFullScreenPopup} />
        </Layout>
    )
}
export default StaticPages
